export const useNavigationStore = defineStore('navigation', () => {
  const navigation = ref<NavigationItem[]>([])
  return { navigation }
})
